<template>
  <button class="gradient-button">button</button>
</template>

<script setup lang="ts">
defineOptions({
  name: 'VGradientButton',
})
</script>
